<div class="fw">
    <file-img-show-view 
        *ngIf="tab && tab.url && validate(tab.name, imageString)"
        [url]="tab.url"
    ></file-img-show-view>
    <file-audio-show-view 
        *ngIf="tab && tab.url 
            && validate(tab.name, audioString)"
        [url]="tab.url"
    ></file-audio-show-view>
    <file-video-show-view 
        *ngIf="tab && tab.url && validate(tab.name, videoString)"
        [url]="tab.url"
    ></file-video-show-view>
    <file-text-show-view 
        *ngIf="tab && tab.url && validate(tab.name, textString)"
        [url]="tab.url"
    ></file-text-show-view>
    <file-pdf-show-view 
        *ngIf="tab && tab.url && validate(tab.name, pdfString)"
        [url]="tab.url"
    ></file-pdf-show-view>
    <file-excel-show-view 
        *ngIf="tab && tab.url 
        && (validate(tab.name, excelString) || validate(tab.name, csvString))"
        [url]="tab.url"
        [fileType]="fileType"
    ></file-excel-show-view>
    <file-doc-show-view 
        *ngIf="tab && tab.url && validate(tab.name, wordString)"
        [url]="tab.url"
    ></file-doc-show-view>
</div>